import { render } from "./IniFileRecordSetting.vue?vue&type=template&id=fe516df2&scoped=true"
import script from "./IniFileRecordSetting.vue?vue&type=script&lang=js"
export * from "./IniFileRecordSetting.vue?vue&type=script&lang=js"

import "./IniFileRecordSetting.vue?vue&type=style&index=0&id=fe516df2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe516df2"]])

export default __exports__